import { render, staticRenderFns } from "./IlmoitusHallitus.vue?vue&type=template&id=4a8a3e8c&scoped=true"
import script from "./IlmoitusHallitus.vue?vue&type=script&lang=js"
export * from "./IlmoitusHallitus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a3e8c",
  null
  
)

export default component.exports